import React, { Component } from "react";
import { connect } from "react-redux";
import { withNamespaces } from 'react-i18next';
import { withRouter } from "react-router-dom";

import userActions from "../../actions/user";
import settingsActions from "../../actions/settings";

import { getMonitorUrl, getPlanning2Url, isStateFetching } from "../../utils"

import LoginForm from "./LoginForm";

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: undefined
    };
  }

  handleSubmit = async ({ organisation, userNumber, password, environment, environmentDisplayName }) => {
    // show URL in browser without query string parameters
    if (window.history.replaceState)
      window.history.replaceState(null, null, '/');

    const { login } = this.props;
    const loginErrorOrResult = await login({ organisation, userNumber, password, environment, environmentDisplayName });

    if (loginErrorOrResult instanceof Error) {
      this.setState({ error: loginErrorOrResult });
      return loginErrorOrResult
    } else {
      const user = loginErrorOrResult;
      const rolesStartingWithRead = user.Roles.filter(r => r.startsWith('Read'));
      if (user.isLoggedIn && !user.isPasswordExpired && !user.isSetNewPassword) {
        if (rolesStartingWithRead.length === 1) {
          // user has access to one specific area only -> automatically redirect to that page
          switch (rolesStartingWithRead[0]) {
            case 'ReadMonitor':
              window.location.replace(getMonitorUrl(user.WebToken));
              break;
            case 'ReadKeyResource':
              window.location.replace(getPlanning2Url(user.WebToken));
              break;
          }
        }
        else if (
          user.Roles.filter(r => r == 'WriteReportPensum').length === 1 &&
          user.Roles.filter(r => r == 'ShowPendingReportPensumsOnLogin').length === 1
        ) {
          window.location.replace(getPlanning2Url(user.WebToken));
        }
      }
    }
  };

  render() {
    const { isLoggedIn } = this.props;

    return (
      <>
        {!isLoggedIn && (
          <LoginForm onSubmit={this.handleSubmit} {...this.props} {...this.state} />
        )}
      </>
    );
  }
}

const mapStateToProps = ({ user, settings }) => ({
  isLoggedIn: user.isLoggedIn,
  loginError: user.loginError,
  settings: settings.settings,
  isFetching: isStateFetching([
    user,
    settings
  ])
});

const mapDispatchToProps = {
  ...userActions,
  ...settingsActions
};

const connectedWithRouter = withRouter(connect(mapStateToProps, mapDispatchToProps)(Login));
export default withNamespaces(['common'])(connectedWithRouter);
